import {FC, useState} from "react";
import {useUsers} from "../../../../queries/useUsers.ts";
import {App, Button, Flex, Popover, Select} from "antd";
import {PlusOutlined, SaveOutlined} from "@ant-design/icons";
import styles from './AddApproversPopover.module.css'
import {EventApprover} from "../../../../types/domain.ts";
import {isRegionManager} from "../../../../utils/userTypeGuards.ts";
import {eventsEventIdApproversPost} from "../../../../api/events/eventsEventIdApproversPost.ts";

type Props = {
    eventId: string;
    approvers: EventApprover[];
    onUpdate: VoidFunction;
}

export const AddApproversPopover: FC<Props> = ({ approvers, eventId, onUpdate }) => {
    const { message } = App.useApp();
    const { data: users } = useUsers();
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<number[]>([]);
    const [loading, setLoading] = useState(false);

    const handleAdd = () => {
        if(!selected.length) return;
        setLoading(true);
        eventsEventIdApproversPost(eventId, { custom_approvers_ids: selected }).then(() => {
            void message.success('Добавлены');
            onUpdate();
            setOpen(false);
        }).catch((e) => {
            void message.error(`Ошибка! ${JSON.stringify(e)}`);
            console.error(e);
        }).finally(() => setLoading(false))
    }

    const popoverContent = (
        <Flex vertical gap={8}>
            <Select
                options={users
                    ?.filter((u) => u.role === 'region_manager' && !approvers.some((a) => a.user?.id === u.id))
                    .map((user) => ({
                        label: `${user.first_name} ${user.last_name} (${isRegionManager(user) && user.region.name})`,
                        value: user.id
                    }))
                }
                mode="multiple"
                showSearch
                optionFilterProp="label"
                className={styles.select}
                placeholder="Выберите согласующих"
                maxTagCount="responsive"
                value={selected}
                onChange={setSelected}
            />
            <Button type="primary" icon={<SaveOutlined />} onClick={handleAdd} loading={loading}>Добавить</Button>
        </Flex>
    )

    return (
        <Popover trigger="click" open={open} onOpenChange={setOpen} content={popoverContent} placement="bottom">
            <Button icon={<PlusOutlined />} className={styles.addApproverButton}>Добавить согласующего</Button>
        </Popover>
    )
}